import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { TransportRoundedIcon } from 'app/icons';
import { TransportForm } from 'app/pages/Transport';
import { useAsyncAction } from 'app/services';
import { transportLoad as mapTransportLoad } from 'app/store/map';
import { transportCreate } from 'app/store/transport';
import React, { useEffect, useRef } from 'react';
const TransportDialog = ({ open, onClose }) => {
    const formRef = useRef(null);
    const { asyncAction: createSubmit, isLoading: isCreateLoading, isSuccessful: isCreateSuccessful, isError: isCreateError, } = useAsyncAction(transportCreate, [open]);
    const { asyncAction: fetchMapTransportData } = useAsyncAction(mapTransportLoad);
    const handleFormClick = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    const handleFormSubmit = (params) => {
        createSubmit(params);
    };
    useEffect(() => {
        if (isCreateSuccessful) {
            fetchMapTransportData();
            onClose();
        }
    }, [isCreateSuccessful]);
    return (React.createElement(Dialog, { maxWidth: 'lg', open: open, onClose: onClose, sx: (theme) => ({
            width: '100%',
            height: '100%',
            '.MuiDialog-paper': {
                minWidth: '540px',
            },
            '.MuiDialogTitle-root': {
                display: 'flex',
                padding: theme.spacing(2),
                alignItems: 'center',
            },
            '.MuiDialogTitle-root .MuiTypography-root': {
                marginLeft: theme.spacing(2),
            },
            '.MuiDialogTitle-root .MuiButtonBase-root': {
                marginLeft: 'auto',
            },
            '.MuiDialogContent-root': {
                padding: theme.spacing(0),
            },
            '.MuiDialogContent-root .simplebar-container': {
                padding: theme.spacing(0, 2),
            },
            '.MuiDialogActions-root': {
                padding: theme.spacing(2),
                justifyContent: 'flex-end',
            },
            '.MuiAvatar-circular': {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
                svg: {
                    width: '18px',
                    height: '18px',
                },
                path: {
                    fill: theme.palette.primary.main,
                },
            },
            '.MuiAlert-root': {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                borderRadius: theme.shape.borderRadius,
            },
        }) },
        React.createElement(DialogTitle, null,
            React.createElement(Avatar, null,
                React.createElement(TransportRoundedIcon, { fontSize: 'small' })),
            React.createElement(Typography, { component: 'span' }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E"),
            React.createElement(IconButton, { color: 'default', onClick: onClose },
                React.createElement(Close, { fontSize: 'small' }))),
        React.createElement(DialogContent, null,
            React.createElement(Scrollbar, null,
                React.createElement(TransportForm, { ref: formRef, onSubmit: handleFormSubmit }),
                !isCreateLoading && isCreateError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")))),
        React.createElement(DialogActions, null,
            React.createElement(LoadingButton, { variant: 'contained', loading: isCreateLoading, onClick: handleFormClick, disableElevation: true }, "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C"))));
};
export default TransportDialog;
